export class Model {
  public Id!: string;
}
